import produce from 'immer';
import { Reducer } from 'redux';
import actionTypes from 'store/actionTypes';

export const announcementsReducer: Reducer<any> = (
  announcementData = {},
  action,
) => {
  if (!action) {
    return [];
  }

  return produce(announcementData, (draft) => {
    switch (action.type) {
      case actionTypes.SET_ANNOUNCEMENTS:
        draft.announcements = action.payload;
        break;
      case actionTypes.SET_ANNOUNCEMENT_LOGS:
        draft.announcementLogs = action.payload;
        break;
      default:
        return draft;
    }
  });
};
